module.exports = __webpack_public_path__ + "static/media/project4.a3a993c8.jpg";